exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pointer-font[data-v-9eed1ecc]{cursor:pointer;color:#2828ff;text-decoration:underline;text-underline-position:under}", ""]);

// exports
